import React from "react";
import styled from "styled-components";

const Element = styled.button`
  width: 100%;
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 100%;
  border: 2px solid #e96159;
  border-radius: 8px;
  padding: 16px 0px;
  background: #ffffff;
  color: #e96159;
  cursor: pointer;
`;

const ElementInverted = styled.button`
  width: 100%;
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 100%;
  border: 2px solid #ffffff;
  border-radius: 8px;
  padding: 16px 0px;
  background: #e96159;
  color: #ffffff;
  cursor: pointer;
`;

const Holder = styled.div`
  width: 100%;
  padding: 16px 16px;
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  border: 1px solid #e96159;
  border-bottom: none;
  border-top: none;
`;

const Wrapper = styled.div`
  border-top: 1px solid #e96159;
  /* border-bottom: 1px solid #e96159; */
  width: 100%;
`;

export default function Button({
  children,
  inverted,
  callback,
  bottom,
  top,
  disabled,
}) {
  return (
    <Wrapper>
      <Holder>
        {inverted ? (
          <ElementInverted
            style={{
              marginTop: top ? top : 0,
              marginBottom: bottom ? bottom : 0,
              background: disabled ? "#ccc" : "#e96159",
            }}
            disabled={disabled}
            onClick={callback ? callback : () => {}}
          >
            {children}
          </ElementInverted>
        ) : (
          <Element
            style={{
              marginTop: top ? top : 0,
              marginBottom: bottom ? bottom : 0,
            }}
            onClick={callback ? callback : () => {}}
          >
            {children}
          </Element>
        )}
      </Holder>
    </Wrapper>
  );
}
